<template>
  <div class="step step2">
    <div class="form">
      <div class="form-title">{{ labels.installationsTitle }}</div>
      <div class="form-fields">
        <div class="ftb vertical installations">
          <div class="ftb-selectors">
            <div
              v-for="(installation, index) in state.installations"
              :key="index"
              class="ftb-selector"
              :class="{
                selected: index === currentInstallation,
                invalid: installation.invalid,
              }"
              :data-target="`installation_${index}`"
              @click="onTabChanged(index)"
            >
              <a>{{ `${labels.sample} ${index + 1}` }}</a>
            </div>
            <div
              class="ftb-selector add-button"
              v-if="state.installations.length < freeSamples"
              @click="onAddInstallation"
            >
              <a>{{ labels.addInstallation }}</a>
            </div>
          </div>
          <div class="ftb-panes">
            <div
              v-for="(installation, index) in state.installations"
              class="ftb-pane"
              :key="index"
              :class="{ selected: index === currentInstallation }"
              :id="`installation_${index}`"
            >
              <Installation
                v-model="state.installations[index]"
                :lists="lists"
                ref="installations"
              >
              </Installation>
              <div class="button-container">
                <FlatButton
                  v-if="state.installations.length < freeSamples"
                  class="inline"
                  white
                  inline
                  :label="labels.addInstallation"
                  @click="onAddInstallation(index)"
                ></FlatButton>
                <FlatButton
                  v-if="state.installations.length > 1"
                  class="inline"
                  white
                  inline-right
                  :label="labels.removeInstallation"
                  @click="onRemoveInstallation(index)"
                ></FlatButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FlatButton } from "clariant-vue3-forms";
import Installation from "./Installation.vue";
import { Labels, State, DataLayer, Utils } from "../services.js";

export default {
  name: "Installations",
  components: {
    Installation,
    FlatButton
  },
  props: {
    freeSamples: Number
  },
  data() {
    return {
      state: State,
      labels: Labels,
      lists: null,
      currentInstallation: 0,
    };
  },
  mounted() {
    let count = 0;
    console.log("Waiting for Asset Manager to become available.");
    let interval = setInterval(() => {
      if (window.cla && window.cla.assetManager) {
        console.log("Asset manager became available.");
        this.initTabBox();
        clearInterval(interval);
        return;
      }
      count++;
      if (count > 10) {
        console.error(
          "Asset Manager was not initialized. The Antifrogen Sample Submission Wizard will not work properly."
        );
        clearInterval(interval);
      }
    }, 1000);
  },
  methods: {
    validateStep() {
      if (!this.$refs.installations || this.$refs.installations.length === 0)
        return false;
      let ret = true;
      for (let i = 0; i < this.$refs.installations.length; i++) {
        const inst = this.$refs.installations[i];
        if (!inst.validateInstallation()) {
          ret = false;
        }
      }
      if (!ret) {
        Utils.showStatusMessage(this.labels.invalidFields, "yellow");
      }
      return ret;
    },
    onTabChanged(tab) {
      console.log(`Tab changed to ${tab}`);
      this.currentInstallation = tab;
    },
    onAddInstallation() {
      State.installations.push(DataLayer.newInstallation());
      this.currentInstallation = State.installations.length - 1;
      document
        .querySelector(".step2 .ftb-selector.add-button")
        .classList.remove("selected");
    },
    onRemoveInstallation(index) {
      console.log(`User requested the removal of installation ${index}`);
      if (index < 0 || index >= State.installations.length) return;
      if (confirm(`${Labels.removeConfirmation}`)) {
        State.installations.splice(index, 1);
        if (index >= State.installations.length) {
          this.currentInstallation = index - 1;
        }
        Utils.showStatusMessage(Labels.installationRemoved, "green");
      }
    },
    initTabBox() {
      let self = this;
      let tabbox = document.querySelector(`.step2 .ftb`);
      window.cla.assetManager.loadStylesheet(
        "/styles/components/flat-tab-box.css"
      );
      window.cla.assetManager.loadScript(
        "/scripts/components/flat-tab-box.js",
        function () {
          if (tabbox && !tabbox.classList.contains("initialized")) {
            //this happens if the tabbox script was already loaded (so, it's not the first load of the editor)
            if (window.cla && window.cla.tabBoxes && window.cla.tabBoxes.init) {
              window.cla.tabBoxes.init();
            }
          }
          console.log("Tab box initialized");
          DataLayer.loadLists()
            .then((res) => {
              self.lists = res;
            })
            .catch((err) => {
              let msg = err.Message || err;
              Utils.showStatusMessage(msg, "red");
            });
        }
      );
    },
  },
};
</script>

<style scoped>
.installations {
  margin-top: 40px;
}

.ftb > .ftb-selectors > .ftb-selector.add-button > a {
  color: #2655FF;
}

.ftb-selector.invalid > a {
  color: #fc7373 !important;
}

a.button.inline {
  display: inline-block;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.feedback-note {
  padding: 20px 20px 20px 210px;
  background-color: #f4f4f4;
}
</style>
